import { WindowWrapper } from 'login-utils/globalWrappers';
import objectToFormData from 'object-to-formdata';

type FormPostParams = Record<string, any>;
type Methods = 'post' | 'get';

// istanbul ignore next: (UI-5482)
export function formPost(path: string, params: FormPostParams = {}, method: Methods = 'post') {
  const formData = objectToFormData(params, { indices: true });
  const form = document.createElement('form');
  form.setAttribute('method', method);
  form.setAttribute('action', path);

  // Returns Iterator primitive -- so for loop is necessary here
  for (const [name, value] of formData.entries()) {
    const hiddenField = WindowWrapper.document.createElement('input');
    hiddenField.setAttribute('type', 'hidden');
    hiddenField.setAttribute('name', name);
    hiddenField.setAttribute('value', value);
    form.appendChild(hiddenField);
  }

  WindowWrapper.document.body.appendChild(form);
  form.submit();
}
